// Copyright (c) Docugami, Inc. All rights reserved.

import { useState } from 'react';
import { BugType, useCreateBugReportMutation } from "store/frontend/frontendSlice";
import { FileManagerInstance } from 'filemanager/FileManager';
import { IDocumentCommand } from 'components/file_management/DocumentCommand';
import { createFolderIdString } from 'components/file_management/file_helpers';

/**
 * Command used for uploading current page to blob storage
 */
export const useBugReportCommand = (docsetId: string, fileId: string, types: BugType[], pageNum?: number): IDocumentCommand => {
    const [isCompleted, setIsCompleted] = useState(false);
    const [createBugReport] = useCreateBugReportMutation();
    
    function onClick() {
        if (!!pageNum) {
            types.forEach(bugType => createBugReport({
                docsetId: docsetId,
                fileId: fileId,
                pageNum: pageNum,
                type: bugType
            }));
            setIsCompleted(true);
        }
    }

    function isEnabled() {
        if (isCompleted) {
            return false;
        }

        let isEnabled = false;
        if (!!pageNum && types.length > 0) {
            const folderId = createFolderIdString(docsetId, fileId)
            const file = FileManagerInstance.getFileFromFolderId(folderId);
            isEnabled = !!file?.properties.hasCpml;
        }

        return isEnabled;
    }

    return {
        id: "BugReport",
        isActive: false,
        label: isCompleted ? "Bug Reported" : "Create Bug Report",
        isEnabled: isEnabled(),
        visual: null,
        execute: onClick
    }
}
